import React from 'react';
import { Textarea as BaseTextarea } from '../../FormElements';
import { useCustomComponent } from '@/hooks';

export interface ChatInputTextareaProps
  extends React.ComponentProps<typeof BaseTextarea> {}

const ChatInputTextareaComponent: React.FC<ChatInputTextareaProps> = props => {
  return <BaseTextarea {...props} />;
};

export const ChatInputTextarea: React.FC<ChatInputTextareaProps> = (
  props: ChatInputTextareaProps
) => {
  const Component = useCustomComponent({
    componentName: 'ChatInputTextarea',
    Component: ChatInputTextareaComponent,
  });

  return <Component {...props} />;
};


